import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/images/no-pic.png'


const _hoisted_1 = { class: "page-content" }
const _hoisted_2 = { class: "custom-card" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "card-image",
  src: _imports_0,
  alt: "商品图片"
}
const _hoisted_5 = { class: "card-content" }
const _hoisted_6 = { class: "card-title" }
const _hoisted_7 = { class: "card-desc" }
const _hoisted_8 = { class: "card-price" }
const _hoisted_9 = { class: "price-text" }

import CustomTitleBar from "@/components/CustomTitleBar/index.vue";
import { onMounted, ref } from "vue";
import { getNewGoodsList } from "@/api/shop";
import { showToast } from "vant";
import { useRouter } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const router = useRouter();

const baseUrl = process.env.VUE_APP_IMG_BASE_URL;

const goodsList = ref<any[]>([]);

const getList = () => {
  getNewGoodsList({
    current: 1,
    size: 99999
  }).then((res) => {
    if (res.code === 200) {
      goodsList.value = res.data;
    } else {
      goodsList.value = [];
      showToast(res.msg);
    }
  });
};

onMounted(() => {
  getList();
});

const goDetail = (item: any) => {
  router.push({ path: '/ShopDetail', query: { item: JSON.stringify(item) } });
};

return (_ctx: any,_cache: any) => {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CustomTitleBar, { title: "周边市集" }),
    _createElementVNode("div", _hoisted_1, [
      (goodsList.value.length === 0)
        ? (_openBlock(), _createBlock(_component_el_empty, {
            key: 0,
            description: "暂无数据",
            image: require('@/assets/images/empty.png')
          }, null, 8, ["image"]))
        : (_openBlock(), _createBlock(_component_van_row, {
            key: 1,
            gutter: "12"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodsList.value, (item) => {
                return (_openBlock(), _createBlock(_component_van_col, {
                  key: item.id,
                  span: "12",
                  onClick: ($event: any) => (goDetail(item))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (item.picture)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "card-image",
                            src: _unref(baseUrl) + item.picture,
                            alt: "商品图片"
                          }, null, 8, _hoisted_3))
                        : (_openBlock(), _createElementBlock("img", _hoisted_4)),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("span", _hoisted_6, _toDisplayString(item.detailTitle), 1),
                        _createElementVNode("span", _hoisted_7, _toDisplayString(item.subTitle) + " - " + _toDisplayString(item.price) + "元", 1),
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("span", _hoisted_9, "￥" + _toDisplayString(item.price), 1)
                        ])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ]),
            _: 1
          }))
    ])
  ], 64))
}
}

})